import { Translate } from 'types/commons';

export const getColumn = (translate: Translate, code: string = 'vi') => {
    let column = '';

    if (translate && typeof translate == 'object' && code in translate) {
        column = translate[code];
    }

    if (typeof translate == 'string') {
        column = translate;
    }

    return column;
};

export const formatCode = (text: string) => {
  try {
    const indent = (str: string, level: number) => '  '.repeat(level) + str;

    let level = 0;
    const formattedLines: string[] = [];
    const lines = text.split('\n').map(line => line.trim()).filter(line => line);

    lines.forEach(line => {
      if (line.startsWith('</')) {
        level = Math.max(0, level - 1);
        formattedLines.push(indent(line, level));
      } else if (line.startsWith('<') && !line.startsWith('<!')) {
        formattedLines.push(indent(line, level));
        const tagNameMatch = line.match(/^<([a-zA-Z0-9]+)/);
        const isSelfClosing = line.endsWith('/>');
        const noClosingTags = ['br', 'img', 'hr', 'input', 'meta', 'link'];
        if (tagNameMatch && !isSelfClosing && !noClosingTags.includes(tagNameMatch[1])) {
          level++;
        }
      } else {
        formattedLines.push(indent(line, level));
      }
    });

    return formattedLines.join('\n');
  } catch (e) {
    return text;
  }
};

export function findTranslate(translates: Translate[] = [], type: string, code: string = 'vi') {
  const translate: Translate | undefined = translates?.find((translate: Translate) => {
    return translate.type === type
  })

  return translate ? translate[code] : '';
}
